import { Item } from "~/components/glossaryBrands/types"
import BrandCard from "~/components/glossaryBrands/BrandCard"
import { useEffect, useRef } from "react"

interface GlossaryContainerSectionProps {
  brands: [string, Item[]]
  hasSearch: boolean
  onIntersecting: (id: string) => void
}

export default function GlossaryContainerSection(
  { brands, hasSearch, onIntersecting }: GlossaryContainerSectionProps,
) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return

    const onScroll = () => {
      if (!ref.current) return

      const top = ref.current.getBoundingClientRect().y
      const titleSize = 68
      const headerSize = globalThis.innerWidth < 1024 ? 140 : 83
      if (top >= 0 && top <= headerSize + titleSize) onIntersecting(ref.current.id)
    }

    document.addEventListener('scroll', onScroll)
    return () => document.removeEventListener('scroll', onScroll)
  }, [])

  if (!brands?.[1]?.length && hasSearch) return null

  const key = brands[0]
  const brand = brands[1]

  return (
    <div ref={ref} id={key} className='w-full px-4 py-5 flex flex-col gap-5'>
      <span className='font-sans font-extrabold text-red-wine text-xl'>
        {key}
      </span>

      <div className='gap-2 md:gap-4 lg:gap-6 xl:gap-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full'>
        {brand.map((item) => <BrandCard key={item.label} item={item} />)}
      </div>
    </div>
  )
}
